import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommunicationService {
  private editSystemDesignSubject = new Subject<number>();
  private designSolutionSubject = new Subject<void>();
  editSystemDesign$ = this.editSystemDesignSubject.asObservable();
  editDesignSolution$ = this.designSolutionSubject.asObservable();
  triggerEditSystemDesign(stepper: number) {
    this.editSystemDesignSubject.next(stepper);
  }

  triggerCheckValidStepper() {
    this.designSolutionSubject.next();
  }
  constructor() { }
}
